import { render, staticRenderFns } from "./photoOverlay.vue?vue&type=template&id=fbc43a5e&scoped=true"
import script from "./photoOverlay.vue?vue&type=script&lang=js"
export * from "./photoOverlay.vue?vue&type=script&lang=js"
import style0 from "./photoOverlay.vue?vue&type=style&index=0&id=fbc43a5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc43a5e",
  null
  
)

export default component.exports